<template>
    <div class="footer_ai">
        <p>相关链接： <a href="/contact_us/company_produce" target="_blank">关于我们</a> | <a href="/contact_us/contact_us" target="_blank">联系我们</a>
            | <a href="/contact_us/safety-payment" target="_blank">汇款账号</a> | <a href="http://sc.sd235.com/" target="">免费素材</a> | <a href="/APP" target="_blank">APP下载</a></p>
        <p>业务部总机： 028-8664-1863 值班人员手机：136-9964-5470</p>
        <p>蜀ICP备14021078号-1 | 川公网安备51010602000255号</p>
    </div>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    export default {
        name:'sd-footer',
        props: [],
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        updated(){

        },
        created(){

        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// sdFooter.vue?743e8152